<div class="sw-cam-panel" [class.sw-cam-embedded]="embedded">

  <!-- HEADER — omitted when embedded; the host <sw-drawer> provides the chrome. -->
  @if (!embedded) {
  <div class="sw-cam-header">
    <h2 class="sw-cam-title">Cameras</h2>
    <button type="button" class="sw-cam-close" aria-label="Close" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
  }

  <!-- BODY -->
  <div class="sw-cam-body custom-sw-scroll">

    <!-- Site-level object detection -->
    @if (siteData && !falseFlag && !isShowOnlyCamera) {
    <div class="sw-detection-block">
      <!-- Site-wise alert active — applies to every camera of this site. -->
      <div class="sw-detection-row">
        <span class="sw-detection-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
        </span>
        <span class="sw-detection-label">Alert Active</span>
        <label class="sw-switch">
          <input type="checkbox" [checked]="siteAlertActive" (change)="toggleSiteAlertActive()">
          <span class="sw-switch-track"></span>
        </label>
      </div>
      <div class="sw-detection-row">
        <span class="sw-detection-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="8" r="5"></circle>
            <path d="M20 21a8 8 0 0 0-16 0"></path>
          </svg>
        </span>
        <span class="sw-detection-label">Face detection</span>
        <label class="sw-switch">
          <input type="checkbox" [checked]="siteFaceDetection" (change)="toggleFaceDetection()">
          <span class="sw-switch-track"></span>
        </label>
      </div>
      <div class="sw-detection-row">
        <span class="sw-detection-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H5.24a2 2 0 0 0-1.8 1.1l-.8 1.63A6 6 0 0 0 2 12.42V16h2"></path>
            <circle cx="6.5" cy="16.5" r="2.5"></circle>
            <circle cx="16.5" cy="16.5" r="2.5"></circle>
          </svg>
        </span>
        <span class="sw-detection-label">Vehicle detection</span>
        <label class="sw-switch">
          <input type="checkbox" [checked]="siteVehicleDetection" (change)="toggleVehicleDetection()">
          <span class="sw-switch-track"></span>
        </label>
      </div>
      <div class="sw-detection-row">
        <span class="sw-detection-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </span>
        <span class="sw-detection-label">
          Zone Active
          <!-- <i class="fa fa-info-circle ms-1" aria-hidden="true" placement="top"
            [ngbTooltip]="getZoneActiveMessage()" tooltipClass="custom-tooltip"></i> -->
        </span>
        <label class="sw-switch">
          <input type="checkbox" [checked]="siteZoneDetection" (change)="toggleZoneDetection()">
          <span class="sw-switch-track"></span>
        </label>
      </div>
      <!-- Site-wise RTSP recording — master switch for every camera of this site. -->
      <div class="sw-detection-row">
        <span class="sw-detection-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 3.5v-11l-4 3.5Z"></path>
            <circle cx="8" cy="12" r="2.5"></circle>
          </svg>
        </span>
        <span class="sw-detection-label">RTSP Recording</span>
        @if (siteRtspUnavailable) {
        <span class="sw-camera-type-badge">No Live URL</span>
        }
        <label class="sw-switch" [class.is-disabled]="siteRtspUnavailable">
          <input type="checkbox" [checked]="siteRtspRecording" [disabled]="siteRtspUnavailable"
            (change)="toggleSiteRtspRecording()">
          <span class="sw-switch-track"></span>
        </label>
      </div>
    </div>
    }

    <!-- Cameras by level. The same setting as the select on each card, seen as lists: a
         site is usually sorted in one sitting ("these four are High, the rest stay Low"),
         and that is a list operation.

         A camera shows in ONE list only - each offers what the other two are not holding.
         Taking a camera out parks it (its card keeps the level the server still has) until
         it is dropped into another list. -->
    @if (!falseFlag && !isShowOnlyCamera) {
    <div class="sw-cam-priority-block">
      <div class="sw-cam-priority-head">
        <span class="sw-cam-interval-label d-inline-flex align-items-center gap-1">
          Alert Priority
          <span class="sw-hint-icon" role="button" tabindex="0" title="How alert priority works"
            (click)="manual.open('alert-priority')" (keydown.enter)="manual.open('alert-priority')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 16v-4"></path>
              <path d="M12 8h.01"></path>
            </svg>
          </span>
        </span>
        <span class="sw-cam-interval-hint">Pick the cameras for each level. Remove a camera from its list to move it
          elsewhere.</span>
      </div>

      @for (option of priorityOptions; track option.value) {
      <div class="sw-cam-priority-row" [ngClass]="'sw-cam-priority-row--' + option.value">
        <span class="sw-cam-priority-level">
          <i class="fa" [ngClass]="option.icon" aria-hidden="true"></i>
          {{ option.label }}
        </span>
        <sw-select class="sw-cam-select sw-cam-priority-select" [multiple]="true"
          [options]="priorityCameraOptions[option.value] || []" optionLabel="display_name" optionValue="_id"
          placeholder="Select cameras" [showClear]="false" appendTo="body" [disabled]="isApplyingPriority"
          [(ngModel)]="priorityBuckets[option.value]" (selectionChange)="onPriorityBucketChange(option.value)">
        </sw-select>

        <!-- The level's time window, beside its cameras. A fixed-width column so the
             three levels' controls line up whether they hold a chip or the add link, and
             so neither ever squeezes the camera list into the drawer edge. -->
        <span class="sw-cam-priority-window">
          @if (priorityWindows[option.value]; as window) {
          <!-- The overnight fact moves to the tooltip here rather than a badge: the chip
               has to stay inside a fixed column beside a camera list, and the hours are
               what has to be readable at a glance. The editor still shows "+1 day". -->
          <button type="button" class="sw-cam-window-chip" (click)="openWindowEditor(option.value)"
            [disabled]="priorityScheduleSaving" [class.is-open]="isWindowEditorOpen(option.value)"
            [ngbTooltip]="windowCrossesMidnight(window) ? 'Runs past midnight into the next day. Click to edit.' : 'Edit these hours'"
            triggers="hover">
            <span class="sw-cam-window-chip-text">{{ windowSummary(option.value) }}</span>
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </button>
          } @else {
          <button type="button" class="sw-cam-window-add" (click)="openWindowEditor(option.value)"
            [disabled]="priorityScheduleSaving || priorityScheduleLoading"
            [class.is-open]="isWindowEditorOpen(option.value)"
            triggers="hover">
            <i class="fa fa-clock-o" aria-hidden="true"></i> Add hours
          </button>
          }
        </span>
      </div>

      @if (isWindowEditorOpen(option.value) && windowDraft) {
      <div class="sw-cam-window-editor" [ngClass]="'sw-cam-window-editor--' + option.value">
        <button type="button" class="sw-cam-window-close" (click)="closeWindowEditor()"
          [disabled]="priorityScheduleSaving" title="Cancel" aria-label="Cancel">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <!-- PrimeNG rather than <input type="time">: the native control opens the
             browser's own hour/minute/AM-PM dropdown, which cannot be styled to match the
             drawer and offers no seconds. appendTo="body" for the same reason every select
             here uses it — the panel would otherwise be clipped by the drawer. -->
        <div class="sw-cam-window-editor-line">
          <div class="sw-cam-window-field">
            <label class="sw-cam-window-field-label" for="swCamWindowStart-{{ option.value }}">Start time</label>
            <p-datepicker inputId="swCamWindowStart-{{ option.value }}" class="sw-cam-window-time"
              [(ngModel)]="windowDraftStart" [timeOnly]="true" hourFormat="12" [showSeconds]="true" [showIcon]="true"
              iconDisplay="input" [readonlyInput]="true" appendTo="body" [disabled]="priorityScheduleSaving"
              inputStyleClass="sw-cam-window-time-input" (ngModelChange)="onWindowTimeChange()"
              ariaLabel="Start time"></p-datepicker>
          </div>
          <div class="sw-cam-window-sep-col" aria-hidden="true">
            <span class="sw-cam-window-field-label sw-cam-window-field-label--ghost">&nbsp;</span>
            <span class="sw-cam-window-sep">→</span>
          </div>
          <div class="sw-cam-window-field">
            <label class="sw-cam-window-field-label" for="swCamWindowEnd-{{ option.value }}">End time</label>
            <p-datepicker inputId="swCamWindowEnd-{{ option.value }}" class="sw-cam-window-time"
              [(ngModel)]="windowDraftEnd" [timeOnly]="true" hourFormat="12" [showSeconds]="true" [showIcon]="true"
              iconDisplay="input" [readonlyInput]="true" appendTo="body" [disabled]="priorityScheduleSaving"
              inputStyleClass="sw-cam-window-time-input" (ngModelChange)="onWindowTimeChange()"
              ariaLabel="End time"></p-datepicker>
          </div>

          <span class="sw-cam-window-editor-actions">
            @if (priorityWindows[option.value]) {
            <button type="button" class="sw-cam-window-icon-btn sw-cam-window-icon-btn--danger"
              (click)="removeWindow(option.value)" [disabled]="priorityScheduleSaving" title="Remove"
              aria-label="Remove this schedule">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
            }
            <button type="button" class="sw-cam-window-save" (click)="saveWindowEditor()"
              [disabled]="priorityScheduleSaving || !!windowDraftOverlap">
              @if (!priorityScheduleSaving) {
              <i class="fa fa-check" aria-hidden="true"></i>
              }
              {{ priorityScheduleSaving ? 'Saving…' : 'Save' }}
            </button>
          </span>
        </div>

        <!-- Shown as the pickers move, not only after Save is pressed: the clash is with
             a level further up or down the panel, so the operator cannot see for
             themselves why these hours are refused. -->
        @if (windowDraftOverlap) {
        <div class="sw-cam-window-error">{{ windowDraftOverlap }}</div>
        } @else if (windowDraftError) {
        <div class="sw-cam-window-error">{{ windowDraftError }}</div>
        }
        <!-- Hours on a level nobody has put a camera in do nothing at all, and nothing
             else on screen says so — the chip shows the times either way. -->
        @if (!(priorityBuckets[option.value] || []).length) {
        <div class="sw-cam-window-hint sw-cam-window-hint--warn">No cameras at this level yet, so these hours do
          nothing. Pick cameras in the list above.</div>
        }
        <div class="sw-cam-window-hint">This level applies <strong>only</strong> between these hours, every day.
          Outside them these cameras are not at this level. Two levels cannot share the same hours.</div>
      </div>
      }
      }
    </div>
    }

    <!-- Quick Disarm interval — common for all cameras (main camera drawer).
         "Disarm All" is a button rather than a change handler on purpose: it mutes
         every camera at this site, which is not something a mis-click should do. -->
    @if (!falseFlag && !isShowOnlyCamera) {
    <div class="sw-cam-interval sw-cam-interval--disarm">
      <!-- Line one stays exactly as it was: label left, interval right. -->
      <div class="sw-cam-interval-row">
        <span class="sw-cam-interval-label d-inline-flex align-items-center gap-1">
          Quick Disarm Interval
          <span class="sw-hint-icon" role="button" tabindex="0" title="How quick disarm works"
            (click)="manual.open('quick-disarm-interval')" (keydown.enter)="manual.open('quick-disarm-interval')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 16v-4"></path>
              <path d="M12 8h.01"></path>
            </svg>
          </span>
        </span>
        <sw-select class="sw-cam-select sw-cam-interval-select" [options]="disarmTimeOptions" optionLabel="name"
          optionValue="value" placeholder="Select Time" [showClear]="false" appendTo="body"
          [(ngModel)]="selectedTime">
        </sw-select>
      </div>

      <div class="sw-cam-interval-foot">
        <span class="sw-cam-interval-hint">Applies to every camera at this site.</span>
        <div class="sw-cam-interval-actions">
          <button type="button" class="sw-cam-interval-link" (click)="toggleIntervalCustomTime()">
            {{ showIntervalCustomTime ? 'Close' : 'Add time' }}
          </button>
          <button type="button" class="sw-cam-interval-apply"
            [disabled]="!selectedTime || isApplyingIntervalToAll || !camera.length"
            ngbTooltip="Quick disarm every camera at this site for the selected interval" triggers="hover"
            (click)="applyIntervalToAllCameras()">
            @if (isApplyingIntervalToAll) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            }
            {{ isApplyingIntervalToAll ? 'Disarming…' : 'Disarm All' }}
          </button>
        </div>
      </div>

      <!-- Live state of the site's disarm: how long is left before every camera is armed
           again, and the way to end it early. Shown only while something is disarmed. -->
      @if (disarmedCameras.length) {
      <div class="sw-cam-disarm-status" [class.is-expired]="isSiteDisarmExpired">
        <span class="sw-cam-disarm-status-dot"></span>
        <span class="sw-cam-disarm-status-text">
          @if (isSiteDisarmExpired) {
          Disarm time is over — {{ disarmedCameras.length }} camera{{ disarmedCameras.length > 1 ? 's' : '' }} still
          disarmed.
          } @else {
          <strong>{{ siteCountdown() }}</strong> remaining · {{ disarmedCameras.length }} of {{ camera.length }} cameras
          disarmed
          }
        </span>
        <button type="button" class="sw-cam-disarm-stop" [disabled]="isStoppingSiteDisarm"
          ngbTooltip="Arm every disarmed camera at this site now" triggers="hover" (click)="stopSiteDisarm()">
          @if (isStoppingSiteDisarm) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          {{ isStoppingSiteDisarm ? 'Stopping…' : 'Stop' }}
        </button>
      </div>
      }

      @if (showIntervalCustomTime) {
      <div class="sw-cam-interval-custom">
        <div class="sw-cam-interval-custom-fields">
          <div class="sw-cam-interval-custom-field">
            <label class="sw-cam-interval-custom-label" for="swCamDisarmHours">Hours</label>
            <input id="swCamDisarmHours" type="number" class="sw-cam-interval-custom-input"
              [(ngModel)]="customIntervalHours" min="0" [max]="maxDisarmHours">
          </div>
          <span class="sw-cam-interval-custom-sep">:</span>
          <div class="sw-cam-interval-custom-field">
            <label class="sw-cam-interval-custom-label" for="swCamDisarmMinutes">Minutes</label>
            <input id="swCamDisarmMinutes" type="number" class="sw-cam-interval-custom-input"
              [(ngModel)]="customIntervalMinutes" min="0" max="59">
          </div>
          <div class="sw-cam-interval-custom-actions">
            <button type="button" class="sw-cam-interval-custom-cancel" [disabled]="isSavingCustomInterval"
              (click)="toggleIntervalCustomTime()">Cancel</button>
            <button type="button" class="sw-cam-interval-custom-save"
              [disabled]="isSavingCustomInterval || !!customIntervalError" (click)="saveCustomInterval()">
              {{ isSavingCustomInterval ? 'Saving…' : 'Add' }}
            </button>
          </div>
        </div>
        <!-- Held back until something is typed: an empty picker is not an error yet. -->
        @if (customIntervalError && (customIntervalHours || customIntervalMinutes)) {
        <span class="sw-cam-interval-custom-error">{{ customIntervalError }}</span>
        } @else {
        <span class="sw-cam-interval-custom-hint">Saved to the shared interval list, up to {{ maxDisarmHours }}
          hours.</span>
        }
      </div>
      }
    </div>
    }

    <!-- Interval controls (quick-disarm mode) -->
    @if (falseFlag) {
    <div class="sw-cam-interval">
      <div class="sw-cam-interval-left">
        <label class="sw-cam-interval-label">Set Time Interval</label>
        <sw-select class="sw-cam-select" [options]="hours" optionLabel="time" optionValue="time"
          placeholder="Select Time" [showClear]="false" [(ngModel)]="selectedTime">
        </sw-select>
      </div>
      <label class="sw-switch">
        <input type="checkbox" id="flexSwitchCheckChecked" [(ngModel)]="allSelectToggle" (change)="selectFn($event)">
        <span class="sw-switch-track"></span>
      </label>
    </div>
    }

    <!-- Camera cards -->
    <div class="sw-camera-list">
      @for (item of camera; track item; let i = $index) {
      <div class="sw-camera-card">

        <div class="sw-camera-card-logo" role="button" (click)="clickCamera(item._id)">
          @if (item.alert_image) {
          <img class="sw-camera-card-img" [src]="item.alert_image" alt="Camera" (error)="onImageError(i)" />
          } @else {
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="m22 8-6 4 6 4V8Z"></path>
            <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
          </svg>
          <div><span class="sw-camera-logo-sight">Sight</span><span class="sw-camera-logo-watch">Watch</span></div>
          }
        </div>

        <div class="sw-camera-card-body">
          <div class="d-flex align-items-start justify-content-between gap-2">
            <div class="min-w-0">
              @if (item.isShowEditMode) {
              <div class="sw-camera-title-edit">
                <input type="text" class="sw-camera-rename-input" [(ngModel)]="item.display_name" />
                <button type="button" class="sw-camera-rename-confirm" title="Save" (click)="saveCameraNewName(item, i)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </button>
                <button type="button" class="sw-camera-rename-cancel" title="Cancel"
                  (click)="item.isShowEditMode = false; item.display_name = item.cloneDisplayName">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              } @else {
              <div class="sw-camera-card-title">
                <span class="sw-camera-card-name" role="button" (click)="clickCamera(item._id)">{{ item?.display_name }}</span>
                @if (!isShowOnlyCamera && canEditCameraOrZone) {
                <button type="button" title="Rename display name"
                  (click)="item.isShowEditMode = true; item.cloneDisplayName = item.display_name">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                  </svg>
                </button>
                }
              </div>
              }
            </div>
            <div class="d-flex align-items-center gap-2 flex-shrink-0">
              <!-- Read-only: the level is SET in the three lists at the top of the drawer,
                   and shown here so a card answers "what is this camera" without scrolling
                   back up. A camera with no priority shows no badge — that is the default
                   state, not something to label. -->
              @if (item.alert_priority) {
              <span class="sw-camera-priority-badge" [ngClass]="'sw-camera-priority-badge--' + item.alert_priority">
                <i class="fa" [ngClass]="priorityIcon(item.alert_priority)" aria-hidden="true"></i>
                {{ priorityLabel(item.alert_priority) }}
              </span>
              }
              @if (item.camera_type || item.type) {
              <span class="sw-camera-type-badge">{{ item.camera_type || item.type }}</span>
              }
              @if (item.live_url_index != null) {
              <span class="sw-camera-type-badge" [ngbTooltip]="item.live_url_name || ''" triggers="hover">
                Live URL {{ item.live_url_index + 1 }}
              </span>
              } @else if (item.live_url_index === null) {
              <span class="sw-camera-type-badge">No Live URL</span>
              }
            </div>
          </div>

          <p class="sw-camera-card-info">Info: This is only the display name. The original camera name cannot be changed.</p>

          @if (!falseFlag && !isShowOnlyCamera) {
          <div class="sw-camera-card-row">
            <div class="sw-camera-zone-wrap">
              <sw-select class="sw-cam-select" [options]="cameraLocationOptions" optionLabel="label" optionValue="id"
                [showClear]="false" placeholder="Select zone" [(ngModel)]="item.selectedCameraLocation"
                (selectionChange)="onCameraLocationChange(item, $event)">
              </sw-select>
            </div>
            @if (canEditCameraOrZone) {
            <button type="button" class="sw-camera-create-zone-btn" (click)="openZoomModal(item)">Create Zone</button>
            }
          </div>

          <!-- Camera-wise alert active + detection toggles + quick disarm — one row.
               Detection pills are effective only when the matching site flag
               is also on; otherwise shown disabled with a hint.
               Inert pills carry `aria-disabled`, not `disabled`: a disabled button
               dispatches no mouse events, so its "Enable at site level first" tooltip
               never appeared on hover. Each handler already returns early when its site
               flag is off, so the click stays a no-op either way.
               `triggers="hover"` everywhere — the default is "hover focus", which leaves
               the tooltip pinned open after a click because the button keeps focus. -->
          <div class="sw-camera-card-row sw-camera-card-row--last sw-camera-detection-row">
            <button type="button" class="sw-labeled-switch" [class.is-on]="item.is_alert_active"
              (click)="toggleCameraAlert(item)" ngbTooltip="Camera alert active" triggers="hover">
              <span class="sw-labeled-switch-dot"></span>
              <!-- Fixed label: the knob and fill say on/off, and swapping the word would
                   change the pill's width every time it is clicked. -->
              Alert Active
            </button>
            <button type="button" class="sw-labeled-switch" [class.is-on]="item.is_face_detection"
              [class.is-disabled]="!siteFaceDetection" [attr.aria-disabled]="!siteFaceDetection"
              [ngbTooltip]="!siteFaceDetection ? cameraDetectionTooltip() : ''" triggers="hover"
              (click)="toggleCameraFaceDetection(item)">
              <span class="sw-labeled-switch-dot"></span>
              Person
            </button>
            <button type="button" class="sw-labeled-switch" [class.is-on]="item.is_vehicle_detection"
              [class.is-disabled]="!siteVehicleDetection" [attr.aria-disabled]="!siteVehicleDetection"
              [ngbTooltip]="!siteVehicleDetection ? cameraDetectionTooltip() : ''" triggers="hover"
              (click)="toggleCameraVehicleDetection(item)">
              <span class="sw-labeled-switch-dot"></span>
              Vehicle
            </button>
            <button type="button" class="sw-labeled-switch" [class.is-on]="item.is_zone_detection"
              [class.is-disabled]="!siteZoneDetection" [attr.aria-disabled]="!siteZoneDetection"
              [ngbTooltip]="!siteZoneDetection ? cameraDetectionTooltip() : ''" triggers="hover"
              (click)="toggleCameraZoneDetection(item)">
              <span class="sw-labeled-switch-dot"></span>
              Zone
            </button>
            <button type="button" class="sw-labeled-switch" [class.is-on]="item.is_rtsp_recording"
              [class.is-disabled]="!siteRtspRecording || !hasLiveUrl(item)" [attr.aria-disabled]="!siteRtspRecording || !hasLiveUrl(item)"
              [ngbTooltip]="!hasLiveUrl(item) ? 'No Live URL for this camera' : (!siteRtspRecording ? cameraDetectionTooltip() : 'Records Live URL ' + (item.live_url_index + 1))" triggers="hover"
              (click)="toggleCameraRtspRecording(item)">
              <span class="sw-labeled-switch-dot"></span>
              Recording
            </button>
            <button type="button" class="sw-labeled-switch" [class.is-on]="item.is_interval_active"
              (click)="toggleCameraQuickDisarm(item)"
              [ngbTooltip]="item.is_interval_active ? 'Arm this camera again' : 'Quick disarm this camera'"
              triggers="hover">
              <span class="sw-labeled-switch-dot"></span>
              Quick Disarm
            </button>

            <!-- Next to the pill, so a disarmed camera says how long it stays that way
                 and can be armed again without opening anything. -->
            @if (item.is_interval_active) {
            <span class="sw-camera-disarm-timer" [class.is-expired]="isDisarmExpired(item)">
              @if (isDisarmExpired(item)) {
              <span class="sw-camera-disarm-timer-text">Disarm time is over</span>
              } @else {
              <span class="sw-camera-disarm-timer-text">{{ cameraCountdown(item) }} left</span>
              }
              <button type="button" class="sw-camera-disarm-timer-stop" ngbTooltip="Arm this camera now"
                triggers="hover" (click)="toggleCameraQuickDisarm(item)">Stop</button>
            </span>
            }
          </div>

          <!-- Inline interval picker for this camera — opened by the pill above, so
               disarming always states how long rather than inheriting a stale interval. -->
          @if (quickDisarmCameraId === item._id) {
          <div class="sw-camera-card-row sw-camera-disarm-inline">
            <span class="sw-camera-disarm-inline-label">Disarm for</span>
            <!-- Appended to body so the panel is not clipped by the drawer's scroll box —
                 and so PrimeNG flips it above the trigger for the last camera in the list. -->
            <sw-select class="sw-cam-select sw-camera-disarm-inline-select" [options]="disarmTimeOptions"
              optionLabel="name" optionValue="value" placeholder="Select Time" [showClear]="false" appendTo="body"
              [(ngModel)]="quickDisarmTime">
            </sw-select>
            <button type="button" class="sw-camera-disarm-inline-cancel"
              (click)="cancelCameraQuickDisarm()">Cancel</button>
            <button type="button" class="sw-camera-disarm-inline-confirm" [disabled]="!quickDisarmTime"
              (click)="confirmCameraQuickDisarm(item)">Disarm</button>
          </div>
          }
          }
        </div>

        @if (falseFlag && !isShowOnlyCamera) {
        <label class="sw-switch sw-cam-interval-switch">
          <input type="checkbox" [(ngModel)]="item.is_interval_active" (change)="changeToggleItem()">
          <span class="sw-switch-track"></span>
        </label>
        }
      </div>
      }

      @if (!camera || camera.length === 0) {
      <div class="sw-cam-empty">No cameras found.</div>
      }
    </div>
  </div>

  <!-- FOOTER (schedule save) -->
  @if (isModelSchedule()) {
  <div class="sw-cam-footer">
    <button type="button" class="sw-cam-save-btn" (click)="saveCameraModel()">
      {{ loading() ? 'Please wait...' : 'Save' }}
    </button>
  </div>
  }
</div>
